import { render, staticRenderFns } from "./PostManager.vue?vue&type=template&id=3906130a&scoped=true&"
import script from "./PostManager.vue?vue&type=script&lang=js&"
export * from "./PostManager.vue?vue&type=script&lang=js&"
import style0 from "./PostManager.vue?vue&type=style&index=0&id=3906130a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3906130a",
  null
  
)

export default component.exports